import {
    requestLogin, requestUserInfo, requestUserBadge
} from "@/api";

import {getToken} from "@/util";
import {setToken} from "@/util";

const actions = {

    async getUserInfo({commit}, token) {
        let result = await requestUserInfo({token})
        // console.log('result:', result)
        if (result.code === '200') {
            commit("GET_USER_INFO", result.data)
            return 'ok'
        } else {
            return Promise.reject(new Error('getUserInfo error'))
        }
    },

    async getUserBadge({commit}) {
        let result = await requestUserBadge()
        // console.log('result:', result)
        if (result.code === '200') {
            commit("GET_USER_BADGE", result.data)
            return 'ok'
        } else {
            return Promise.reject(new Error('getUserInfo error'))
        }
    },


    async submitLoginForm({commit}, data) {
        let result = await requestLogin(data)
        console.log('submitLoginForm:', result)
        if (result.code === '200') {
            setToken('LH_TOKEN', result.data.token)
            setToken('LH_ROLE_MENU', JSON.stringify(result.data.userMenus))
            commit('REQUEST_LOGIN', result.data)

            return 'ok'
        } else {
            return Promise.reject(new Error(result.message))
        }
    }
}

const mutations = {

    REQUEST_LOGIN(state, data) {
        state.token = data.token
        state.userInfo = data
    },
    GET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo
    },
    GET_USER_BADGE(state, badgeInfo) {
        state.badgeInfo = badgeInfo.length
    },

}
const state = {
    badgeInfo: 0,
    userInfo: {},
    userMenus: getToken('LH_ROLE_MENU'),
    token: getToken('LH_TOKEN')
}
const getters = {}

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
}
